import script from "./ClassesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassesList.vue?vue&type=script&setup=true&lang=js"

import "./ClassesList.vue?vue&type=style&index=0&id=059e4261&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059e4261"]])

export default __exports__